export enum PartsUsageStatus {
  All = 0,
  Issued = 1,
  Returned = 2
}

export enum PartsUsageItemStatus {
  Issued = 'Issued',
  Returned = 'Returned'
}